import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { t } from "../../i18n";

const CorporatePage = () => {
    const { lang } = useLanguage();
    const qualityItems = t(lang, "corporate.qualityItems");

    return (
        <div className="mt-[122px] md:pt-[130px] lg:pt-[140px] bg-background pb-20 text-foreground min-h-screen">
            <div className="mx-auto max-w-4xl px-4 py-12">
                {/* HAKKIMIZDA */}
                <section className="mb-20">
                    <header className="mb-8 border-b border-primary/30 pb-4">
                        <h1 className="text-3xl md:text-4xl font-bold tracking-tight uppercase text-primary">
                            {t(lang, "corporate.aboutTitle")}
                        </h1>
                    </header>
                    <div className="space-y-6 text-muted-foreground leading-relaxed text-base md:text-lg">
                        <p>{t(lang, "corporate.aboutText1")}</p>
                        <p>{t(lang, "corporate.aboutText2")}</p>
                        <p>{t(lang, "corporate.aboutText3")}</p>
                        <p>{t(lang, "corporate.aboutText4")}</p>
                        <p>{t(lang, "corporate.aboutText5")}</p>
                    </div>
                </section>

                {/* MİSYON & VİZYON */}
                <section className="mb-20">
                    <header className="mb-8 border-b border-primary/30 pb-4">
                        <h2 className="text-3xl md:text-4xl font-bold tracking-tight uppercase text-primary">
                            {t(lang, "corporate.missionTitle")}
                        </h2>
                    </header>

                    <div className="grid gap-12 md:grid-cols-2">
                        <div>
                            <h3 className="text-xl font-bold text-foreground mb-4 uppercase tracking-wider border-l-4 border-primary pl-4">
                                {t(lang, "corporate.missionSub")}
                            </h3>
                            <p className="text-muted-foreground leading-relaxed">
                                {t(lang, "corporate.missionText")}
                            </p>
                        </div>
                        <div>
                            <h3 className="text-xl font-bold text-foreground mb-4 uppercase tracking-wider border-l-4 border-primary pl-4">
                                {t(lang, "corporate.visionSub")}
                            </h3>
                            <p className="text-muted-foreground leading-relaxed">
                                {t(lang, "corporate.visionText")}
                            </p>
                        </div>
                    </div>
                </section>

                {/* KALİTE POLİTİKAMIZ */}
                <section>
                    <header className="mb-8 border-b border-primary/30 pb-4">
                        <h2 className="text-3xl md:text-4xl font-bold tracking-tight uppercase text-primary">
                            {t(lang, "corporate.qualityTitle")}
                        </h2>
                    </header>
                    <div className="text-muted-foreground leading-relaxed">
                        <p className="mb-6 italic text-lg">
                            {t(lang, "corporate.qualityIntro")}
                        </p>
                        <h4 className="text-foreground font-bold mb-4 uppercase">{t(lang, "corporate.qualitySubtitle")}</h4>
                        <ul className="space-y-4">
                            {Array.isArray(qualityItems) && qualityItems.map((item, idx) => (
                                <li key={idx} className="flex items-start">
                                    <span className="text-primary mr-2 mt-1">●</span>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default CorporatePage;
